/** Fired immediately before auth logout on idle timeout (TC-AUT-003). Handlers must not save forms. */
export const IDLE_LOGOUT_EVENT = 'intellicare:idle-logout';

export function dispatchIdleLogout(): void {
  window.dispatchEvent(new CustomEvent(IDLE_LOGOUT_EVENT));
}

/** Cancel pending debounced auto-saves (Tab2_Consultation etc.) without persisting. */
export const CANCEL_AUTOSAVE_EVENT = 'intellicare:cancel-autosave';

export function dispatchCancelAutoSave(): void {
  window.dispatchEvent(new CustomEvent(CANCEL_AUTOSAVE_EVENT));
}

export type LogoutReason = 'idle' | 'unauthorized';

export type SessionEndLogoutFn = (reason: LogoutReason) => void;

/**
 * Session end: discard unsaved UI state, clear auth, show login (never redirect to Dashboard).
 * Does not call saveFormData or any form persistence APIs.
 */
export function performSessionEndLogout(logout: SessionEndLogoutFn, reason: LogoutReason = 'idle'): void {
  dispatchCancelAutoSave();
  dispatchIdleLogout();
  logout(reason);
}
